import React, { useCallback, useContext, useMemo } from "react";
import { WATaskSingleSettingsScreenProps } from "../WATaskSingleStack";

import { graphql, usePreloadedQuery, useQueryLoader } from "react-relay";
import { FlatList } from "react-native-gesture-handler";
import {
  TaskListItemIcon,
  TaskListItemTitle,
} from "../../../../../../../components/TaskListItem";
import { AHSeparator, ListItem, useBoxStyle } from "arkh";
import { WATaskSingleContext } from "../WATaskSingleContext";

import { keyExtractorId } from "../../../../WidgetAdd/utils/keyExtractors";
import { TaskSelectListEmpty } from "../../../../../../../components/TaskSelectListEmpty";

export const WA_TASK_SINGLE_SETTINGS_SELECT_TASK_QUERY = graphql`
  query WATaskSingleSettingsSelectTaskQuery($routineId: ID!) {
    routine(id: $routineId) {
      id
      title
      activeVersion {
        id
        tasks {
          id
          ...TaskListItemIcon_Task
          ...TaskListItemTitle_Task
          __typename
        }
      }
    }
  }
`;

export function WATaskSingleSettingsTasks(
  props: WATaskSingleSettingsScreenProps<"WATaskSingleSettingsSelectTask">
) {
  const context = useContext(WATaskSingleContext);
  const [queryRef] = useQueryLoader(
    WA_TASK_SINGLE_SETTINGS_SELECT_TASK_QUERY,
    props.route.params.queryRef
  );
  if (!queryRef) {
    throw new Error("WATaskSignleSettings query ref null");
  }

  const data = usePreloadedQuery(
    WA_TASK_SINGLE_SETTINGS_SELECT_TASK_QUERY,
    queryRef
  );

  const tasks = useMemo(
    () =>
      data.routine?.activeVersion.tasks.filter(
        ({ __typename }) => __typename !== "TaskText"
      ) ?? [],
    [data.routine?.activeVersion.tasks]
  );

  const renderItem = useCallback(
    ({ item, index }: { item: (typeof tasks)[number]; index: number }) => {
      return (
        <ListItem
          isFirst={index === 0}
          isLast={index === (tasks?.length ?? 1) - 1}
          onPress={() => {
            context.setSectionIds([]);
            context.setTaskId(item.id);
            props.navigation.navigateDeprecated("WATaskSingleSettings", {});
          }}
          left={<TaskListItemIcon task={item} />}
          right={<ListItem.NavArrow />}
        >
          <TaskListItemTitle task={item} />
        </ListItem>
      );
    },
    [context, props.navigation, tasks?.length]
  );

  const contentContainerStyle = useBoxStyle({
    space: "medium",
    spaceTop: "medium",
  });

  return (
    <FlatList
      data={tasks}
      ListEmptyComponent={
        <TaskSelectListEmpty routineTitle={data.routine?.title ?? ""} />
      }
      ItemSeparatorComponent={AHSeparator}
      renderItem={renderItem}
      keyExtractor={keyExtractorId}
      contentContainerStyle={contentContainerStyle}
    />
  );
}
